import CommonService from "@/domain/dataTable/commonService/CommonService.js";
export default class DocumentosService extends CommonService {
  async getDbData() {
    let mock = await this.mockJson();
    return mock;
  }

  async getDocsFederal( imoveis ) {
    const response = imoveis;
    let newArray = [];
    response.items.map(item => {
      const name = item.descricao ? '_' + item.descricao : '';
      
      if(newArray.length == 0 || !newArray.find(node => node.idPasta == `${item.uf}-${item.municipio}`)){
        newArray.push(
          { 
            nome: `${item.uf}-${item.municipio}`, 
            idPasta: `${item.uf}-${item.municipio}`,
          }
        );
      }

      if(!newArray.find(node => node.idPasta == `${item.inscricaoImovel} ${name}`)){
        newArray.push(
          { 
            nome: `${item.inscricaoImovel} ${name}`,
            idPai: `${item.uf}-${item.municipio}`,
            idPasta: `${item.inscricaoImovel} ${name}`, 
          }
        );
      }

      if(item.iptu.length > 0) {
        item.iptu.map(iptu => {
          if(!newArray.find(node => node.idPasta == iptu.ano + '-' + item.inscricaoImovel)){
            newArray.push(
              { 
                nome: iptu.ano,
                idPai: `${item.inscricaoImovel} ${name}`,
                idPasta: iptu.ano + '-' + item.inscricaoImovel,
                arquivos: [
                  {
                    nome: iptu.nomeArq,
                    idDocumento: iptu._id,
                    path: iptu.path,
                    idImovel: item._id,
                    dataIni: new Date(iptu.createdAt).toLocaleString('pt-BR'),
                    dataMod: new Date(iptu.updatedAt).toLocaleString('pt-BR'),
                  }
                ], 
              }
            );
          }else {
            let fileArray = newArray.find(node => node.idPasta == iptu.ano + '-' + item.inscricaoImovel);
            fileArray.arquivos.push(
              {
                nome: iptu.nomeArq,
                idDocumento: iptu._id,
                path: iptu.path,
                idImovel: item._id,
                dataIni: new Date(iptu.createdAt).toLocaleString('pt-BR'),
                dataMod: new Date(iptu.updatedAt).toLocaleString('pt-BR'),
              }
            )
          }
        });
      }
    });

    return newArray;
  }

  async getIptu(idImovel, idIptu) {
    return this._resource.get(`imoveis/${idImovel}/pdf/${idIptu}`).then(
      success => {
        var data = new Uint8Array(success.body.pdf.data);
        return this.bufferToBase64(data);
      },
      failed => {
        return this.bufferToBase64('');
      }
    );
  }



    async convertJson(array) {
      let copyDadosEmpresa = [...array];

      let treeDados = copyDadosEmpresa
        .filter((pasta) => !pasta.idPai)
        .map((pasta) => {
          return {
            ...pasta,
            children: [],
            root: true,
            expanded: false,
          };
        });

      copyDadosEmpresa = copyDadosEmpresa.filter((pasta) => !treeDados.some((tPasta) => tPasta.idPasta === pasta.idPasta));

      for (let i = 0; i < treeDados.length; i++) {
        const pai = treeDados[i];
        pai.children = this.buscaFilhos(pai.idPasta, copyDadosEmpresa);
      }

      

      return treeDados;
    }

    buscaFilhos(idPai, array, expanded = false) {
      const filhos = array
        .filter((filho) => filho.idPai === idPai)
        .map((filho) => {
          return {
            ...filho,
            children: [],
            expanded,
          };
        });
      array = array.filter((pasta) => !filhos.some((tPasta) => tPasta.idPasta === pasta.idPasta));
    
      for (let i = 0; i < filhos.length; i++) {
        const filho = filhos[i];
        filho.children = this.buscaFilhos(filho.idPasta, array);
      }
      return filhos;
    }

    async mockJson() {
      return {
        empresa: "123412345",
        situacao_fiscal: [
          {
            idPasta: "12345633",
            nome: "2020",
            origin: true,
          },
          {
            idPasta: "123456",
            idPai: "12345633",
            nome: "São Paulo",
            origin: true,
          },
          {
            idPasta: "16121324123412355345",
            idPai: "123456",
            nome: "NOME1 - CNPJ",
            origin: true,
            arquivos: [
              {
                nome: "teste",
                idDocumento: "123afsd3412aaaaa",
                origem: "robo",
              },
            ],
          },
          {
            idPasta: "16122423411134345",
            idPai: "123456",
            nome: "NOME2 - CNPJ",
            origin: true,
            arquivos: [
              {
                nome: "teste",
                idDocumento: "123afsd3412aaaaa",
                origem: "robo",
              },
            ],
          },
          {
            idPasta: "161212341234345",
            idPai: "123456",
            nome: "NOME3 - CNPJ",
            origin: true,
            arquivos: [
              {
                nome: "teste",
                idDocumento: "123afsd3412aaaaa",
                origem: "robo",
              },
            ],
          },
          {
            idPasta: "16123423214342345",
            idPai: "123456",
            nome: "NOME4 - CNPJ",
            origin: true,
            arquivos: [
              {
                nome: "teste",
                idDocumento: "123afsd3412aaaaa",
                origem: "robo",
              },
            ],
          },
          {
            idPasta: "16124342355342345",
            idPai: "123456",
            nome: "NOME5 - CNPJ",
            origin: true,
            arquivos: [
              {
                nome: "teste",
                idDocumento: "123afsd3412aaaaa",
                origem: "robo",
              },
            ],
          },
          {
            idPasta: "16123421123122345",
            idPai: "123456",
            nome: "NOME6 - CNPJ",
            origin: true,
            arquivos: [
              {
                nome: "teste",
                idDocumento: "123afsd3412aaaaa",
                origem: "robo",
              },
            ],
          },
          {
            idPasta: "1612342342342432342342345",
            idPai: "123456",
            nome: "NOME7 - CNPJ",
            origin: true,
            arquivos: [
              {
                nome: "teste",
                idDocumento: "123afsd3412aaaa2242a",
                origem: "robo",
              },
            ],
          },
          {
            idPasta: "2342342211",
            idPai: "123456",
            nome: "NOME8 - CNPJ",
            origin: true,
            arquivos: [
              {
                nome: "teste",
                idDocumento: "123afsd3412aaa234234aa",
                origem: "robo",
              },
            ],
          },
          {
            idPasta: "123234234",
            idPai: "123456",
            nome: "NOME9 - CNPJ",
            origin: true,
            arquivos: [
              {
                nome: "teste",
                idDocumento: "123afsd3412aa23424aaa",
                origem: "robo",
              },
              {
                nome: "teste3.pdf",
                idDocumento: "123asdfsd3412",
                origem: "robo",
              },
            ],
          },
          {
            idPasta: "1612567",
            idPai: "123456",
            nome: "NOME10 - CNPJ",
            origin: true,
            arquivos: [
              {
                nome: "teste3.pdf",
                idDocumento: "123afsd3412asda",
                origem: "robo",
              },
              {
                nome: "teste4.pdf",
                idDocumento: "123asdfsd3412asd",
                origem: "robo",
              },
            ],
          },
          {
            idPasta: "161211234556363345",
            idPai: "123456",
            nome: "NOME11 - CNPJ",
            origin: true,
            arquivos: [
              {
                nome: "teste",
                idDocumento: "123afsd3412aaaaa",
                origem: "robo",
              },
            ],
          },
        ],
    }
  }
}


// WEBPACK FOOTER //
// ./src/domain/documentos/Documentos.js